module.exports = __webpack_public_path__ + "img/com.electrolux.eprone3dr.a56e20bb.webp";